import { createFileRoute } from "@tanstack/react-router";
import ComoFuncionaSeoLocalIA from "@/pages/ComoFuncionaSeoLocalIA";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const canonicalUrl = "https://agenciaseoevolution.com/como-funciona-seo-local-ia";

const steps = [
  {
    title: "1. Auditoría Automatizada con IA",
    description:
      "Revisamos Google Business Profile, web, reseñas, información de servicio y consultas disponibles. Las herramientas ayudan al análisis; el equipo contrasta los datos y documenta la situación inicial.",
  },
  {
    title: "2. Análisis de Competencia Local",
    description:
      "Comparamos fichas y páginas relevantes de la zona para identificar diferencias y tareas posibles. La competencia y las oportunidades se validan en el diagnóstico.",
  },
  {
    title: "3. Optimización Inteligente",
    description: "Priorizamos correcciones de ficha, acceso técnico, servicios, horarios y contenido de la web. El alcance se acuerda según las incidencias detectadas.",
  },
  {
    title: "4. Generación de Contenido Localizado",
    description:
      "Preparamos páginas, publicaciones y respuestas útiles sobre servicios y zonas reales. El equipo revisa exactitud y utilidad antes de publicar.",
  },
  {
    title: "5. Gestión de Reseñas con IA",
    description:
      "Diseñamos una solicitud ética de opiniones y respuestas profesionales revisadas por el equipo. No compramos ni fabricamos reseñas.",
  },
  {
    title: "6. Monitorización y Ajustes Continuos",
    description:
      "Revisamos visibilidad, acciones de la ficha y contactos con datos disponibles. Documentamos cambios y siguientes prioridades, sin garantizar resultados.",
  },
];

const howToSchema = {
  "@context": "https://schema.org",
  "@type": "HowTo",
  name: "Cómo Funciona el SEO Local con Inteligencia Artificial",
  description: "Proceso de SEO local y Google Maps: diagnóstico, tareas y evaluación sin garantías de resultados",
  step: steps.map((step, index) => ({
    "@type": "HowToStep",
    position: index + 1,
    name: step.title,
    text: step.description,
  })),
};

const breadcrumbSchema = buildBreadcrumb([{ name: "Cómo funciona el SEO local con IA", path: "/como-funciona-seo-local-ia" }]);

export const Route = createFileRoute("/como-funciona-seo-local-ia")({
  head: () => ({
    meta: [
      { name: "twitter:card", content: "summary_large_image" },
      { title: "Cómo funciona el SEO local y Google Maps | SEOEVOLUTION" },
      {
        name: "description",
        content:
          "Guía del proceso de SEO local: diagnóstico, ficha, contenido, reseñas y evaluación. Tareas y entregables, sin plazos universales ni resultados garantizados.",
      },
      {
        name: "keywords",
        content:
          "cómo funciona SEO local, SEO local IA, inteligencia artificial SEO, Google My Business IA, posicionamiento local automático",
      },
      { property: "og:type", content: "article" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: "Cómo funciona el SEO local y Google Maps | SEOEVOLUTION" },
      {
        property: "og:description",
        content:
          "Guía del proceso de SEO local: diagnóstico, ficha, contenido, reseñas y evaluación. Tareas y entregables, sin plazos universales ni resultados garantizados.",
      },
      { name: "twitter:title", content: "Cómo funciona el SEO local y Google Maps | SEOEVOLUTION" },
      {
        name: "twitter:description",
        content:
          "Guía del proceso de SEO local: diagnóstico, ficha, contenido, reseñas y evaluación. Tareas y entregables, sin plazos universales ni resultados garantizados.",
      },
    ],

    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(breadcrumbSchema), { type: "application/ld+json", children: JSON.stringify(howToSchema) }],
  }),
  component: ComoFuncionaSeoLocalIA,
});
